// 유효성 검사
export const regPass = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{6,25}$/;
export const regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// 숫자만 입력 휴대폰
export const regPhoneonlynum = /^^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;
// 
export const regPhonedash = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/;
